import { useEffect, useState } from 'react';

const identity = (v) => v;

export function useApi(
  fetchCallback,
  {
    enabled = true,
    select = identity,
    onSuccess,
    onError,
  } = {}
) {
  const [state, setState] = useState({
    loading: true,
    error: null,
    data: null,
  });

  useEffect(() => {
    if (enabled) {
      setState((prevState) => ({ ...prevState, loading: true, error: null }));

      fetchCallback({})
        .then((result) => {
          const selected = select(result);
          setState((prevState) => ({
            ...prevState,
            data: selected,
            loading: false,
          }));

          if (onSuccess) {
            onSuccess(selected);
          }
        })
        .catch((e) => {
          setState((prevState) => ({ ...prevState, error: e, loading: false }));
          if (onError) {
            onError(e);
          }
        });
    }
  }, [enabled, fetchCallback, onError, onSuccess, select]);

  return state;
}
